import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ExperiencesRoutingModule } from './experiences-routing.module';
import { SharedModule } from 'src/app/theme/shared/shared.module';
import { AddExperienceComponent } from './add-experience/add-experience.component';
import { AllExperiencesComponent } from './all-experiences/all-experiences.component';
import { ArchwizardModule } from 'angular-archwizard';
import { NgSelectOption, ReactiveFormsModule } from '@angular/forms';
import { ColorPickerModule } from 'ngx-color-picker';
import { NgbDatepickerModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { MediaManagerModule} from '../../components/media-manager/media-manager.module';
import { IntGroupExpComponent } from './int-group-exp/int-group-exp.component';
import { BreadcrumbModule, CardModule } from 'src/app/theme/shared/components';
import { CustomListboxModule } from '../../components/custom-dual-listbox/custom-listbox.module';
import { SortablejsModule } from 'ngx-sortablejs';
import {InteractionListItemModule} from '../../components/interactions/interaction-list-item/interaction-list-item.module';
import { ImageMapComponent } from 'src/app/components/image-map/image-map.component';
import {SelectModule} from 'ng-select';
import { OrderModule } from 'ngx-order-pipe';
import { TinymceModule } from 'angular2-tinymce';


@NgModule({
  declarations: [AddExperienceComponent, AllExperiencesComponent],
  imports: [
    CommonModule,
    ExperiencesRoutingModule,
    ReactiveFormsModule,
    ArchwizardModule,
    SharedModule,
    ColorPickerModule,
    NgbDatepickerModule,
    MediaManagerModule,
    BreadcrumbModule,
    CustomListboxModule,
    SortablejsModule,
    InteractionListItemModule,
    SelectModule,
    OrderModule,
    NgbTooltipModule,
    TinymceModule.withConfig({
      remove_trailing_brs: true,
      remove_linebreaks: true,
      indent: false,
      branding: false,
      auto_focus: false,
      plugins: 'link table',
      contextmenu: 'link table'
    })
  ]
})
export class ExperiencesModule { }
